var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6 -194) translate(6 193) translate(0 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#4A657B"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M20.087 11.593v-.554c0-3.841-3.134-6.975-6.975-6.975-3.84 0-6.975 3.134-6.975 6.975v.554c-1.222.458-2.101 1.643-2.101 3.019 0 1.777 1.452 3.23 3.229 3.23H8.43c.306 0 .555-.25.555-.555v-5.35c0-.306-.249-.555-.555-.555h-.535v-.343c0-2.886 2.332-5.217 5.217-5.217s5.217 2.331 5.217 5.217v.343h-.535c-.306 0-.555.249-.555.555v5.35c0 .306.249.554.555.554h.248c-.554 1.28-1.777 2.178-3.23 2.293-.076-.363-.4-.65-.802-.65h-1.815c-.459 0-.822.363-.822.822v.936c0 .459.363.822.822.822h1.815c.401 0 .745-.287.803-.688 2.159-.115 3.955-1.586 4.567-3.573 1.566-.21 2.79-1.567 2.79-3.191.018-1.395-.86-2.56-2.083-3.02z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSupport);
export default __webpack_public_path__ + "static/media/icon-support.bdecdd937f57dc648363ebe37ec04f2f.svg";
export { ForwardRef as ReactComponent };